import { useCallback } from "react";
import type { StudentQuestionAnswer, StudentTestExercise } from "p6m-p6u";
import UnderlinedInput from "../../../basic/underlinedInput/UnderlinedInput";
import WordBox from "../../../basic/wordBox/WordBox";
import ExerciseWrapper from "./ExerciseWrapper";
import { getExerciseProgress } from "../../../helpers/OnlineTestHelper";

interface CreateTextExerciseProps {
    exercise: StudentTestExercise;
    exerciseIndex: number;
    studentAnswer: StudentQuestionAnswer;
    onAnswerUpdate: (updatedAnswer: StudentQuestionAnswer, exerciseId: string) => void;
}

const CreateTextExercise = (props: CreateTextExerciseProps) => {
    const exerciseId = props.exercise.id;
    const studentAnswer = props.studentAnswer;
    const onAnswerUpdate = props.onAnswerUpdate;

    const words = studentAnswer.jumbledWords ?? [];
    const text = studentAnswer.jumbledWordsAnswer ?? "";
    const starterText = studentAnswer.textFieldStarterText;
    const progress = getExerciseProgress(studentAnswer, props.exercise.questionMode);

    const handleTextChange = useCallback(
        (value: string) => {
            if (!exerciseId) return;
            onAnswerUpdate({ ...studentAnswer, jumbledWordsAnswer: value }, exerciseId);
        },
        [exerciseId, studentAnswer, onAnswerUpdate]
    );

    if (!exerciseId) return null;

    return (
        <ExerciseWrapper
            data-testid="online-test-exercise-create-text"
            number={props.exerciseIndex + 1}
            title={props.exercise.extraComments ?? ""}
            progress={progress}
        >
            <div className="flex flex-col gap-s">
                <WordBox words={words} />
                {starterText && <p className="text-m text-p6-grey-dark">{starterText}</p>}
                <UnderlinedInput
                    data-testid="online-test-create-text-input"
                    text={text}
                    setText={handleTextChange}
                    initialLines={5}
                />
            </div>
        </ExerciseWrapper>
    );
};

export default CreateTextExercise;
